module.exports = __webpack_public_path__ + "static/media/my-account.79c97451.svg";